import { render } from "./Admin.vue?vue&type=template&id=2923ec62&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=2923ec62&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2923ec62"]])

export default __exports__